import challengeLabel from './Content/images/challenge-label.svg'
import panelIngredient from './Content/images/panel-ingredient.svg'
import panelSave from './Content/images/panel-save.svg'
import tasksCheckmark from './Content/images/tasks-checkmark.svg'
import './ImagesPreloader.scss'

const PrintoutImagesPreloader = () => (
  <div className="c-printout-images-preloader">
    <img alt="" src={challengeLabel} />
    <img alt="" src={panelIngredient} />
    <img alt="" src={panelSave} />
    <img alt="" src={tasksCheckmark} />
  </div>
)

export default PrintoutImagesPreloader
